module.exports = __webpack_public_path__ + "img/badge.bb066dde.png";